module.exports = __webpack_public_path__ + "img/app-mockup-session-easy.91ff7feb.png";